export const adaptFrecuenciaProfesional = (frecuenciaProfesionalData) => {
    return {
        id: frecuenciaProfesionalData?.idFrecuenciaProfesional,
        displayName: frecuenciaProfesionalData?.descripccion,
        name: frecuenciaProfesionalData?.descripccion
    }
}

export const adaptFrecuenciaProfesionalArray = (
    frecuenciaProfesionales
) => {
    return structuredClone(frecuenciaProfesionales?.allFrecuenciaProfesional)
        ?.map(frecuenciaProfesional => adaptFrecuenciaProfesional(frecuenciaProfesional));
}